module.exports = __webpack_public_path__ + "static/media/dot.94a7e097.svg";